<template>
	<v-speed-dial v-model="menu" color="secondary" transition="fab-transition">
		<template #activator="{ props: activatorProps }">
			<v-btn
				v-bind="activatorProps"
				icon
				class="menu-button bg-secondary"
				elevation="4"
				size="x-large"
			>
				<v-icon v-if="menu"> mdi-close </v-icon>
				<v-icon v-else> mdi-menu </v-icon>
			</v-btn>
		</template>

		<div key="open-raw-data-container">
			<v-tooltip
				v-if="menu"
				key="open-raw-data-tooltip"
				location="left"
				:model-value="true"
				:open-on-click="false"
				:open-on-hover="false"
				:open-on-focus="false"
				:offset="offset"
			>
				<template #activator="{ props }">
					<v-btn
						v-bind="props"
						key="open-raw-data"
						size="small"
						icon
						color="primary"
						@click="openRawDataViewer"
					>
						<v-icon>mdi-table-eye</v-icon>
					</v-btn>
				</template>
				<span>
					View current data

					<v-icon size="x-small" end> mdi-open-in-new </v-icon>
				</span>
			</v-tooltip>
		</div>

		<div key="open-file-container">
			<v-tooltip
				v-if="menu"
				key="open-file-tooltip"
				location="left"
				:model-value="true"
				:open-on-click="false"
				:open-on-hover="false"
				:open-on-focus="false"
				:offset="offset"
			>
				<template #activator="{ props }">
					<v-btn
						v-bind="props"
						key="open-file"
						size="small"
						icon
						color="primary"
						@click="openFileInNewTab"
					>
						<v-icon>mdi-file-eye-outline</v-icon>
					</v-btn>
				</template>
				<span>
					View current file

					<v-icon size="x-small" end> mdi-open-in-new </v-icon>
				</span>
			</v-tooltip>
		</div>

		<div key="user-manual-container">
			<v-tooltip
				v-if="menu"
				key="user-manual-tooltip"
				location="left"
				:model-value="true"
				:open-on-click="false"
				:open-on-hover="false"
				:open-on-focus="false"
				:offset="offset"
			>
				<template #activator="{ props }">
					<v-btn
						v-bind="props"
						key="user-manual"
						size="small"
						icon
						color="primary"
						@click="openUserManual"
					>
						<v-icon>mdi-book-information-variant</v-icon>
					</v-btn>
				</template>
				<span>User manual</span>
			</v-tooltip>
		</div>

		<div key="qc-comments-container">
			<v-tooltip
				v-if="menu"
				key="qc-comments-tooltip"
				location="left"
				:model-value="true"
				:open-on-click="false"
				:open-on-hover="false"
				:open-on-focus="false"
				:offset="offset"
			>
				<template #activator="{ props }">
					<v-btn
						v-bind="props"
						key="qc-comments"
						size="small"
						icon
						color="primary"
						@click="toggleComments"
					>
						<v-icon>mdi-comment-text-outline</v-icon>
					</v-btn>
				</template>
				<span>QC Comments</span>
			</v-tooltip>
		</div>

		<div key="paper-citation-container">
			<v-tooltip
				v-if="menu"
				key="paper-citation-tooltip"
				location="left"
				:model-value="true"
				:open-on-click="false"
				:open-on-hover="false"
				:open-on-focus="false"
				:offset="offset"
			>
				<template #activator="{ props }">
					<v-btn
						v-bind="props"
						key="paper-citation"
						size="small"
						icon
						color="primary"
						@click="viewPaperCitation"
					>
						<v-icon>mdi-book-open-variant</v-icon>
					</v-btn>
				</template>
				<span>View paper citation</span>
			</v-tooltip>
		</div>
	</v-speed-dial>
</template>

<script>
import { mapActions } from "pinia";
import { useMainStore } from "@/store";

export default {
	name: "DataEntryMenu",

	emits: [
		"open-file-in-new-tab",
		"open-raw-data-viewer",
		"view-paper-citation",
		"toggle-comments",
	],

	setup() {
		return {
			offset: [30, 15],
		};
	},

	data() {
		return {
			fileMap: {},
			menu: false,
		};
	},

	methods: {
		...mapActions(useMainStore, ["setHelp"]),
		openUserManual() {
			this.setHelp("#top");
		},
		openFileInNewTab() {
			this.$emit("open-file-in-new-tab");
		},
		openRawDataViewer() {
			this.$emit("open-raw-data-viewer");
		},
		viewPaperCitation() {
			this.$emit("view-paper-citation");
		},
		toggleComments() {
			this.$emit("toggle-comments");
		},
	},
};
</script>

<style scoped lang="scss">
.menu-button {
	height: 56px;
	width: 56px;
	min-width: 56px;
	position: absolute;
	bottom: 25px;
	right: 25px;
	z-index: 204;
}
</style>
